const getResponseData = (response) => {
  if (response) return response.data;
};

export default getResponseData;
